import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery, useQueryClient } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button, TextField, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { Link as RouterLink } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import { useMutation } from "react-query";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function WithdrawalList() {
  const formatPrice = (amount, currency)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);
  const queryClient = useQueryClient();

    const [withdrawals, setwithdrawals] = useState(null);
    const { isLoading: isLoadingwithdrawals, refetch: getwithdrawals } = useQuery(
        "list-withdrawals",
        async () => {
          return await apiClient.get("/api/list-withdrawals");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setwithdrawals(res.data.withdrawals);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

    // Fetch users for create/edit forms
    const { data: usersData } = useQuery(
        "admin-users",
        async () => {
          return await apiClient.get("/api/users");
        },
        {
          enabled: true,
        }
      );
    
      useEffect(() => {
        getwithdrawals() 
        if (isLoadingwithdrawals) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

      // Create Dialog State
      const [openCreate, setOpenCreate] = useState(false);
      const [createForm, setCreateForm] = useState({
        user_id: '',
        amount: '',
        source: '',
        address: '',
        coin_name: '',
        status: 'pending',
        created_at: ''
      });

      // Edit Dialog State
      const [openEdit, setOpenEdit] = useState(false);
      const [editForm, setEditForm] = useState({
        withdrawal_id: '',
        user_id: '',
        amount: '',
        source: '',
        address: '',
        coin_name: '',
        status: '',
        created_at: ''
      });

      // Delete Dialog State
      const [openDelete, setOpenDelete] = useState(false);
      const [deleteId, setDeleteId] = useState(null);

      const handleOpenCreate = () => {
        setCreateForm({
          user_id: '',
          amount: '',
          source: '',
          address: '',
          coin_name: '',
          status: 'pending',
          created_at: ''
        });
        setOpenCreate(true);
      };

      const handleCloseCreate = () => {
        setOpenCreate(false);
      };

      const handleOpenEdit = (withdrawal) => {
        // Format date for datetime-local input (YYYY-MM-DDTHH:mm)
        let formattedDate = '';
        if (withdrawal.created_at) {
          const date = new Date(withdrawal.created_at);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;
        }
        
        setEditForm({
          withdrawal_id: withdrawal.id,
          user_id: withdrawal.user_id,
          amount: withdrawal.amount,
          source: withdrawal.source,
          address: withdrawal.address,
          coin_name: withdrawal.coin_name || '',
          status: withdrawal.status,
          created_at: formattedDate
        });
        setOpenEdit(true);
      };

      const handleCloseEdit = () => {
        setOpenEdit(false);
      };

      const handleOpenDelete = (id) => {
        setDeleteId(id);
        setOpenDelete(true);
      };

      const handleCloseDelete = () => {
        setOpenDelete(false);
        setDeleteId(null);
      };

      // Create Mutation
      const { isLoading: isCreating, mutate: createWithdrawal } = useMutation(
        async (formData) => {
          return await apiClient.post(`/api/admin/create-withdrawal`, formData);
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                setTimeout(() => {
                  const event = new Event('newMessage');
                  window.dispatchEvent(event);
                }, 1000);
                queryClient.invalidateQueries('list-withdrawals');
                getwithdrawals();
                handleCloseCreate();
              }            
          },
          onError: (err) => {
            let errorMessage = err.response?.data?.message || err.message || 'An error occurred';
            localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
          },
        }
      );

      // Update Full Mutation
      const { isLoading: isUpdatingFull, mutate: updateWithdrawalFull } = useMutation(
        async (formData) => {
          return await apiClient.post(`/api/admin/update-withdrawal-full`, formData);
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                setTimeout(() => {
                  const event = new Event('newMessage');
                  window.dispatchEvent(event);
                }, 1000);
                queryClient.invalidateQueries('list-withdrawals');
                getwithdrawals();
                handleCloseEdit();
              }            
          },
          onError: (err) => {
            let errorMessage = err.response?.data?.message || err.message || 'An error occurred';
            localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
          },
        }
      );

      // Delete Mutation
      const { isLoading: isDeleting, mutate: deleteWithdrawal } = useMutation(
        async (id) => {
          return await apiClient.post(`/api/admin/delete-withdrawal`, { withdrawal_id: id });
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                setTimeout(() => {
                  const event = new Event('newMessage');
                  window.dispatchEvent(event);
                }, 1000);
                queryClient.invalidateQueries('list-withdrawals');
                getwithdrawals();
                handleCloseDelete();
              }            
          },
          onError: (err) => {
            let errorMessage = err.response?.data?.message || err.message || 'An error occurred';
            localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
          },
        }
      );

      const handleCreateSubmit = () => {
        const formData = {
          ...createForm,
          amount: parseFloat(createForm.amount),
          created_at: createForm.created_at ? new Date(createForm.created_at).toISOString() : null
        };
        createWithdrawal(formData);
      };

      const handleEditSubmit = () => {
        const formData = {
          ...editForm,
          amount: parseFloat(editForm.amount),
          created_at: editForm.created_at ? new Date(editForm.created_at).toISOString() : null
        };
        updateWithdrawalFull(formData);
      };

      const handleDeleteConfirm = () => {
        if (deleteId) {
          deleteWithdrawal(deleteId);
        }
      };

  const getDate = (date) => new Date(date).toLocaleString();
  const users = usersData?.data?.users || [];

  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: 20, textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
            {isLoadingwithdrawals ? 'Loading...' : 'List of Withdrawals'}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenCreate}
          >
            Create Withdrawal
          </Button>
        </Box>
    <TableContainer component={Paper}>
        
      {withdrawals !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        <TableCell>User Name</TableCell>
          <TableCell align="right">User Email</TableCell>
          <TableCell align="right">Amount</TableCell>
          <TableCell align="right">Coin</TableCell>
          <TableCell align="right">Address</TableCell>
          <TableCell align="right">Status</TableCell>
          <TableCell align="right">Withdrawal Source</TableCell>
          <TableCell align="right">Date</TableCell>
          <TableCell align="right">Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {withdrawals.map((withdrawal) => (
          <TableRow
            key={withdrawal.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {withdrawal.user.name}
            </TableCell>
            <TableCell align="right">{withdrawal.user.email}</TableCell>
            <TableCell align="right">{formatPrice(withdrawal.amount, withdrawal.user.currency)}</TableCell>
            <TableCell align="right">{withdrawal.coin_name}</TableCell>
            <TableCell align="right" sx={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {withdrawal.address}
            </TableCell>
            <TableCell align="right">{withdrawal.status}</TableCell>
            <TableCell align="right">{withdrawal.source}</TableCell>
            <TableCell align="right">{getDate(withdrawal.created_at)}</TableCell>
            <TableCell align="right">
              <IconButton
                color="primary"
                onClick={() => handleOpenEdit(withdrawal)}
                size="small"
              >
                <EditIcon />
              </IconButton>
              <IconButton
                color="error"
                onClick={() => handleOpenDelete(withdrawal.id)}
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>

    {/* Create Dialog */}
    <Dialog
        open={openCreate}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseCreate}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{textAlign: 'center'}}>{"CREATE NEW WITHDRAWAL"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel htmlFor="user_id">User</InputLabel>
                <Select
                  value={createForm.user_id}
                  onChange={(e) => setCreateForm({...createForm, user_id: e.target.value})}
                  labelId="user_id"
                  id="user_id"
                  name="user_id"
                  label="User"
                >
                  <MenuItem value="">
                    <em>Select User</em>
                  </MenuItem>
                  {users.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.name} ({user.email})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount"
                type="number"
                value={createForm.amount}
                onChange={(e) => setCreateForm({...createForm, amount: e.target.value})}
                inputProps={{ step: "0.01", min: "0.01" }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Coin Name"
                value={createForm.coin_name}
                onChange={(e) => setCreateForm({...createForm, coin_name: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Withdrawal Address"
                value={createForm.address}
                onChange={(e) => setCreateForm({...createForm, address: e.target.value})}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Source"
                value={createForm.source}
                onChange={(e) => setCreateForm({...createForm, source: e.target.value})}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="status">Status</InputLabel>
                <Select
                  value={createForm.status}
                  onChange={(e) => setCreateForm({...createForm, status: e.target.value})}
                  labelId="status"
                  id="status"
                  name="status"
                  label="Status"
                >
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="approved">Approved</MenuItem>
                  <MenuItem value="declined">Declined</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Date (for backdating - leave empty for current date)"
                type="datetime-local"
                value={createForm.created_at}
                onChange={(e) => setCreateForm({...createForm, created_at: e.target.value})}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        
        <DialogActions>
          <Button onClick={handleCloseCreate}>Cancel</Button>
          <Button onClick={handleCreateSubmit} variant="contained" disabled={isCreating}>
            {isCreating ? 'Creating...' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

    {/* Edit Dialog */}
    <Dialog
        open={openEdit}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseEdit}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{textAlign: 'center'}}>{"EDIT WITHDRAWAL"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel htmlFor="edit_user_id">User</InputLabel>
                <Select
                  value={editForm.user_id}
                  onChange={(e) => setEditForm({...editForm, user_id: e.target.value})}
                  labelId="edit_user_id"
                  id="edit_user_id"
                  name="edit_user_id"
                  label="User"
                >
                  {users.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.name} ({user.email})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount"
                type="number"
                value={editForm.amount}
                onChange={(e) => setEditForm({...editForm, amount: e.target.value})}
                inputProps={{ step: "0.01", min: "0.01" }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Coin Name"
                value={editForm.coin_name}
                onChange={(e) => setEditForm({...editForm, coin_name: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Withdrawal Address"
                value={editForm.address}
                onChange={(e) => setEditForm({...editForm, address: e.target.value})}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Source"
                value={editForm.source}
                onChange={(e) => setEditForm({...editForm, source: e.target.value})}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="edit_status">Status</InputLabel>
                <Select
                  value={editForm.status}
                  onChange={(e) => setEditForm({...editForm, status: e.target.value})}
                  labelId="edit_status"
                  id="edit_status"
                  name="edit_status"
                  label="Status"
                >
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="approved">Approved</MenuItem>
                  <MenuItem value="declined">Declined</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Date (for backdating)"
                type="datetime-local"
                value={editForm.created_at}
                onChange={(e) => setEditForm({...editForm, created_at: e.target.value})}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        
        <DialogActions>
          <Button onClick={handleCloseEdit}>Cancel</Button>
          <Button onClick={handleEditSubmit} variant="contained" color="primary" disabled={isUpdatingFull}>
            {isUpdatingFull ? 'Updating...' : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>

    {/* Delete Confirmation Dialog */}
    <Dialog
        open={openDelete}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDelete}
      >
        <DialogTitle sx={{textAlign: 'center'}}>{"DELETE WITHDRAWAL"}</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this withdrawal? This action cannot be undone.
          </Typography>
        </DialogContent>
        
        <DialogActions>
          <Button onClick={handleCloseDelete}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} variant="contained" color="error" disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}
